module.exports = __webpack_public_path__ + "img/list_4_tc.fe8b0b14.png";